import axios from "axios";
import React, { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { env } from "../config";
import * as Actions from "../redux/actions";
import Loader from "../components/Loader";
import Footer from "../components/Footer";
const AgroTechIntro = React.lazy(() => import("../components/AgroTechIntro"));
const AgroTechCardsSection = React.lazy(
  () => import("../components/AgroTechCardsSection")
);
const AgroTechConnectSection = React.lazy(
  () => import("../components/AgroTechConnectSection")
);

function AgroTechPage() {
  const dispatch = useDispatch();
  const AgrotechData: any = useSelector(
    (state: any) => state?.Page?.AgrotechPageContent
  );

  const getAgrotechPageContent = () => {
    axios
      .get(`${env}/api/agrotech-page-content?populate=deep`)
      .then(function (response) {
        dispatch(Actions.AgrotechPageAction(response?.data?.data?.attributes));
      });
  };

  useEffect(() => {
    if (Object.keys(AgrotechData).length === 0) {
      getAgrotechPageContent();
    }
    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
  }, []);

  const isLoading = Object.keys(AgrotechData).length === 0;

  return isLoading ? (
    <Loader />
  ) : (
    <div>
      <Suspense fallback={<Loader />}>
        <AgroTechIntro AgrotechIntro={AgrotechData?.AgrotechIntro} />

        {AgrotechData?.AgrotechCards ? (
          <AgroTechCardsSection AgrotechCards={AgrotechData?.AgrotechCards} />
        ) : null}
        <AgroTechConnectSection
          AgrotechConnectSection={AgrotechData?.AgrotechConnectSection}
        />
        <Footer />
      </Suspense>
    </div>
  );
}

export default AgroTechPage;
